import { Link } from '@tanstack/react-router';

import styles from './collections.module.css';

import { Issue } from '@/constants';
import { Loading } from '@shared/ui/loading';

import { useSection } from '../sections.hooks';

const SECTION_ID = 15;

export function Collections() {
	const { isLoading, issues, error } = useSection(SECTION_ID);
	if (isLoading) {
		return (
			<div style={{ height: '100%' }}>
				<Loading />
			</div>
		);
	}
	if (error) {
		return <div>{error.message}</div>;
	}

	return (
		<div className={styles['view']}>
			<div className={styles['title']}>
				<h1>Featured Collections</h1>
			</div>
			<div className={styles['issues']}>
				{issues.map(issue => (
					<IssueComponent key={issue.id} {...issue} />
				))}
			</div>
		</div>
	);
}

function IssueComponent(issue: Issue) {
	const { id, name, cover, description, slug } = issue;

	const from = `${window.location.pathname}?section=collections`;
	return (
		<Link
			from={from}
			to={'/collections/$id'}
			params={{ id: slug ?? id }}
			className={styles['issue']}
			// Same reasoning as `collection.tsx`'s own `Item` -> issue hop
			// (07.1 Phase 0.37): the shared `Topbar` widget's fixed
			// `view-transition-name: topbar-nav` (topbar.module.css) is
			// already present on both this page (`home.tsx`'s `Topbar` wraps
			// the same widget) and the collection detail page
			// (`collection.tsx`'s `View` uses `@pages/preview-basic`'s
			// `Topbar`, itself a thin wrapper over the identical widget) --
			// without this prop, the navbar (and the rest of the page)
			// hard-cuts between them instead of reading as continuous. No
			// shared-element cover morph here either: `collection.tsx`'s
			// `Content` renders per-article thumbnails, not a single cover
			// image matching this grid item's own `cover`, so there's
			// nothing on the receiving page for it to morph into -- checked
			// directly, not assumed. Same `prefers-reduced-motion` caveat as
			// every other `viewTransition` usage in this codebase: TanStack
			// Router degrades safely when the View Transitions API is
			// unavailable, but doesn't itself check for reduced motion.
			viewTransition
		>
			<div className={styles['logo']}>
				<img loading="lazy" src={cover} alt={`${name} - Cover`} width={120} />
			</div>
			<h3>{name}</h3>
			<div className={styles['description']}>{description}</div>
		</Link>
	);
}
